<template>
        <div>
            <message v-for="(message, key) in messages"
                     :message="message.message"
                     :status="message.status" :key="key">

            </message>
            <div class="form__error" v-if="error" v-html="error">
            </div>
            <transition name="fade-in">
                <div class="form-file" v-if="!hasFile">
                    <input type="file" :name="name" :accept="acceptedTypes" v-on:change="fileChanged($event.target.name, $event.target.files[0])">
                    <div class="form-file__content">
                        <div class="form-file__title"><i class="icon-uploadbutton form-file__icon"></i><T>Upload een bestand</T></div>
                        <div class="form-file__description"><T>Sleep een document of klik om een document te uploaden</T></div>
                    </div>
                </div>
            </transition>

            <transition name="fade">
                <div v-if="hasFile" class="form-file__value">
                    <div class="form-file__value-wrapper" v-if="hasFile">
                        <img class="form-file__img" v-if="showCropper" :src="uploadedFile"/>
                        <i  v-if="!showCropper" class="form-file__value-icon icon-file"></i>
                        <span   v-if="!showCropper" class="form-file__extension">{{currentExtension}}</span>
                    </div>
                </div>

            </transition>

            <slim-cropper class="hide" v-if="showCropper" :options="slimOptions" :service="uploadUrl">
                <img :src="uploadedFile"/>
                <input class="field field__upload"
                       type="file"
                       :name="'slim-'+name"
                       :accept="acceptedTypes">
            </slim-cropper>
            <a v-if="hasFile" class="form-file__delete button button--ghost button--small" href="#" v-on:click="removeFile">
                <T>Verwijderen</T>
            </a>
        </div>
</template>

<script>

    export default {
        name: 'DocumentUploadField',
        props: {
            uploadUrl: String,
            acceptedTypes: String,
            name: String,
        },
        model: {
            file: null,
            event: 'updated'
        },
        data: function(){
            return {
                messages: null,
                hasFile: false,
                error: null,
                uploadedFile: null,
                fileHashId: null,
                showCropper: false,
                currentExtension: null,
                slimOptions: {
                    label:  t('Selecteer een afbeelding'),
                    saveInitialImage: false,
                    push: true,
                    edit: false,
                    service: this.cropImage,
                    rotateButton: false,
                    didInit: this.slimInit,
                    didConfirm: this.didConfirm,
                    popoverClassName: this.$root.theme,
                    buttonConfirmLabel: t('Bevestigen'),
                    buttonCancelLabel: t('Annuleren'),
                    buttonRotateTitle: t('Roteren'),
                },
            };
        },
        methods: {
            calculateCrop(width,height,ratioWidth,ratioHeight) {
                let self = this;
                let newWidth;
                let newHeight;
                let x = 0;
                let y = 0;

                if(!ratioWidth || !ratioHeight) {
                    return;
                }

                //check if current ratio is bigger or smalle then the requested
                if( (width / height) > (ratioWidth / ratioHeight)) {
                    // if smaller then the height is ower baseline
                    newWidth = (height / ratioHeight) * ratioWidth;
                    newHeight = height;
                    // center the box horizontal
                    x =  (width - newWidth) / 2;
                } else {
                    // if bigger then the width is ower baseling
                    newHeight = (width / ratioWidth) * ratioHeight;
                    newWidth = width;
                    // center the box vertical
                    y =  (height - newHeight) / 2;
                }

                self.slimOptions.crop = {x: x, y: y, width: newWidth, height: newHeight};
            },
            setPreview(data) {
                this.file = data.file;
                this.uploadedFile =data.file;
                this.hasFile = true;
                this.fileHashId = data.hashId;
                this.currentExtension = data.extension;
                this.$emit('updated', data.file);

                // check if the file can be cropped (is image)
                if(data.allowCropping) {

                    this.$store.commit('setLoading',true);
                    this.showCropper = data.allowCropping;
                    this.slimOptions.rotateButton = data.allowRotate;

                    this.calculateCrop(data.width,data.height, data.ratioWidth, data.ratioHeight)
                }

                // notify that we have a file uploaded
                this.$root.$emit('fileUploaded',data.possibleNextType, data.allowNewField);
            },
            setError(data) {
                this.error = data.error;
            },
            resetError() {
                this.error = null;
            },
            // called when slim has initialized
            slimInit (data, slim) {

                // open editor
                slim._doEdit();
                this.$store.commit('setLoading',false);
            },
            removeFile(e) {
                e.preventDefault();
                let self = this;

                self.$store.commit('setLoading',true);

                self.$root.$emit('fileDeleted');
                self.$emit('updated', null);
                self.showCropper = false;
                self.file = null;
                self.uploadedFile = null;
                self.hasFile = false;

                // setup request and send
                this.$Api.delete('remove-download/' + this.fileHashId)
                        .then(function(response) {
                            self.fileHashId = null;
                        });
            },
            didConfirm(data) {
                this.$store.commit('setLoading',true);
            },
            cropImage(data, progress, success, failure, slim) {
                let self = this;

                self.resetError();

                // add the fieldName of the slim file
                data.append('fieldName', 'slim-' + this.name);
                data.append('doCrop', true);

                this.save(data)
                    .then(function(response){

                        if(response.data.success) {
                            self.file = response.data.file;
                            self.hasFile = true;
                            self.uploadedFile = response.data.file + '&update=' + Date.now();
                            self.$emit('updated', response.data.file);
                            success();
                        } else {
                            self.setError(response.data);
                        }
                    });
            },
            fileChanged(fieldName, file) {
                // handle file changes
                let self = this;
                let data = new FormData();

                self.$store.commit('setLoading',true);

                // reset errors
                self.resetError();

                // append the file to FormData
                data.append(fieldName, file);
                // add the fieldName of the upload field
                data.append('fieldName', this.name);
                data.append('possibleNextType', this.acceptedTypes);

                this.save(data)
                        .then(function(response) {
                            var data = response.data;
                            // check if we have any errors
                            if(data.success) {
                                self.setPreview(data);
                            } else {
                                self.setError(data);
                            }
                        });
            },
            save(data) {
                // save it
                return this.$Api.post(this.uploadUrl,data)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/components/fields/DocumentUploadField.vue